import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { getFriendlyTableName } from '~/functions/helpers';
export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLog',
  props: {
    objectName: {
      type: String,
      required: true
    },
    tableName: {
      type: String,
      required: true
    },
    dataId: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var auditLogs = ref(null);
    var isOpen = ref(false);
    watch(isOpen, function () {
      if (isOpen.value == true) {
        var _auditLogs$value;
        (_auditLogs$value = auditLogs.value) === null || _auditLogs$value === void 0 ? void 0 : _auditLogs$value.refetch();
      }
    });
    var friendlyTableName = computed(function () {
      return getFriendlyTableName(props.tableName);
    });
    var title = computed(function () {
      return "Audit log for ".concat(friendlyTableName.value, ": ").concat(props.objectName);
    });
    var defaultFilters = computed(function () {
      return {
        tableName: [props.tableName],
        dataId: props.dataId
      };
    });
    return {
      __sfc: true,
      props: props,
      auditLogs: auditLogs,
      isOpen: isOpen,
      friendlyTableName: friendlyTableName,
      title: title,
      defaultFilters: defaultFilters
    };
  }
});